module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_vi-c9b44b8a6b4666ef29a2e5777f0fe56c.jpg";